import { render, staticRenderFns } from "./overdue-detail-comic-staff.vue?vue&type=template&id=6bf08f03"
import script from "./overdue-detail-comic-staff.vue?vue&type=script&lang=tsx"
export * from "./overdue-detail-comic-staff.vue?vue&type=script&lang=tsx"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports